import React, { useCallback, useMemo } from "react";
import Dropdown from "@hs/dropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { getLocalizedText } from "data/utils";
import Icons from "@hs/icons";
import {
    PickerRenderType,
    type PickerRenderTypeEnum,
    PickerRenderTypeEnumValues,
} from "data/types";

export const RenderType = ({ value, allowedRenderTypes, onChange }: Props) => {
    const enumValues = useMemo(
        () =>
            PickerRenderTypeEnumValues.filter(
                (enumValue) =>
                    (enumValue.value & allowedRenderTypes) === enumValue.value
            ),
        [allowedRenderTypes]
    );
    const activeLabel = useMemo(
        () =>
            PickerRenderTypeEnumValues.filter(
                (enumValue) => enumValue.value === value
            ).map((enumValue) => (
                <React.Fragment key={`${enumValue.label}.${enumValue.value}`}>
                    <Icons.Library name={enumValue.icon} />{" "}
                    {getLocalizedText(enumValue.label)}
                </React.Fragment>
            )),
        [allowedRenderTypes]
    );
    if (enumValues.length <= 1) {
        return null;
    }
    return (
        <Dropdown className="picker">
            <Dropdown.Toggle>{activeLabel}</Dropdown.Toggle>
            <Dropdown.Menu>
                {enumValues.map((enumValue, idx) => (
                    <MenuItem
                        eventKey={idx + 1}
                        key={`rendertype.${enumValue.value}`}
                        onClick={() => onChange(enumValue.value)}
                        active={enumValue.value === value}
                    >
                        <Icons.Library name={enumValue.icon} />{" "}
                        {getLocalizedText(enumValue.label)}
                    </MenuItem>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};
RenderType.displayName = "PickerModal.RenderType";
